import React, { useCallback } from 'react';
import { ImageUtil, ROTATION_AMOUNT, ROTATION_MODE } from "../../index.js";
import { usePreviewImages, useViewerState } from "../../hooks/index.js";
export const RotateWidget = props => {
  const viewerState = useViewerState();
  const previewImages = usePreviewImages();

  const rotateFunc = (newRotation, direction, pageIndex) => {
    const existingObj = newRotation.find(rotation => rotation.pageNum === pageIndex);

    if (newRotation.length > 0 && existingObj) {
      const prevValue = existingObj.degree || 0;
      existingObj.degree = ImageUtil.normalizeDegrees((prevValue + (direction === 'left' ? -ROTATION_AMOUNT : ROTATION_AMOUNT) % 360) % 360);
    } else {
      newRotation.push({
        pageNum: pageIndex,
        degree: ImageUtil.normalizeDegrees((0 + (direction === 'left' ? -ROTATION_AMOUNT : ROTATION_AMOUNT) % 360) % 360)
      });
    }
  };

  const rotateDocument = useCallback(direction => {
    var _viewerState$rotation;

    const newRotation = (_viewerState$rotation = viewerState.rotation) !== null && _viewerState$rotation !== void 0 ? _viewerState$rotation : [];

    if (props.pages === 'all') {
      previewImages.imageData.forEach(page => {
        rotateFunc(newRotation, direction, page.Index);
      });
    } else {
      rotateFunc(newRotation, direction, viewerState.activePage);
    }

    viewerState.updateState({
      rotation: newRotation
    });
  }, [previewImages.imageData, props.pages, viewerState]);

  switch (props.mode) {
    case ROTATION_MODE.anticlockwise:
    case ROTATION_MODE.clockwise:
      return props.renderButton(props.mode, rotateDocument);

    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, props.renderButton(ROTATION_MODE.anticlockwise, rotateDocument), props.renderButton(ROTATION_MODE.clockwise, rotateDocument));
  }
};
//# sourceMappingURL=rotate-widget.js.map